import React, { ReactNode } from "react";
import { TagPicker } from "rsuite";

interface Props {
  options: { label: string; value: string; color?: string }[];
  onChange: (values: string[]) => void;
  onClean?: () => void;
  value: string[];
  cleanable?: boolean;
  creatable?: boolean;
  disabled?: boolean;
  renderValue?: any;
  className?: string;
}

const AppTagPicker = ({
  options,
  onChange,
  onClean,
  value,
  cleanable = false,
  disabled = false,
  renderValue = undefined,
  className = "",
}: Props) => {
  return (
    <TagPicker
      data={options}
      onChange={onChange}
      onClean={onClean}
      value={value}
      cleanable={cleanable}
      disabled={disabled}
      renderValue={renderValue}
      className={className}
    />
  );
};

export default AppTagPicker;
